import { loadContent } from './load';
import { rawContent } from './raw';

export * from './schema';
export * from './load';
export { rawContent };

/** Zwalidowana zawartość gry z katalogu data/. */
export const content = loadContent(rawContent);
